import { useSelector } from 'react-redux';

const selectUserBoot = (state) => state.user.boot;

const useUserBoot = () => useSelector(selectUserBoot);

export default useUserBoot;
